<template>
  <div>
    <div class="mb-3">
      <bus-selector
        :value="transportationProfile"
        :disabled="isSearchingFare || isSearchingBus"
        :on-selected-bus="onSelectedBus"
        placeholder="Filter by licence plate or shortcode"
      />
    </div>
    <div class="mb-3">
      <v-select
        :disabled="busRoutes.length === 0 || isSearchingFare"
        :loading="isSearchingBus"
        :items="busRoutes"
        v-model="selectedBusRouteId"
        label="Bus Route"
        placeholder="Select route"
        :menu-props="{ offsetY: true }"
        outlined
      ></v-select>
    </div>
    <div v-if="flatRateFare">
      <div class="text-center mb-3">
        <v-icon class="mr-2" color="error">fas fa-clock</v-icon>
        <v-icon class="mr-2" v-if="transportationProfile && transportationProfile.transportType !== 'smarttransit_minibus'">fas fa-bus-alt</v-icon>
        <v-icon class="mr-2" v-if="transportationProfile && transportationProfile.transportType === 'smarttransit_minibus'">fas fa-bus</v-icon>
        <strong>Express Route - Flat Rate</strong>
      </div>
      <div class="text-center mb-3"><strong>Pickup Bus Stop</strong></div>
      <div class="mb-3">
        <bus-stop-selector
          v-model="selectedOriginBusStop"
          :items="originBusStops"
          :disabled="isSearchingFare"
          empty-text="Select Pickup Stop"
          search-placeholder="Search or select stop name"
        />
      </div>
      <h3 class="text-center mb-3">
        {{ flatRateFareLabel }}
      </h3>
      <v-btn block class="mb-3" :loading="isSearchingFare" :disabled="isSearchingFare" @click="searchFare()">Confirm fare</v-btn>
    </div>
    <div v-else>
      <div class="text-center mb-3"><strong>From</strong></div>
      <div class="mb-3">
        <bus-stop-selector
          v-model="selectedOriginBusStop"
          :items="originBusStops"
          :disabled="isSearchingFare"
          empty-text="Select From Stop"
          search-placeholder="Search or select stop name"
        />
      </div>
      <div class="text-center mb-3"><strong>To</strong></div>
      <div class="mb-5">
        <bus-stop-selector
          v-model="selectedDestinationBusStop"
          :items="destinationBusStops"
          :disabled="isSearchingFare"
          chip-color="primary"
          empty-text="Select To Stop"
          search-placeholder="Search or select stop name"
        />
      </div>
      <v-btn block class="mb-3" :loading="isSearchingFare" :disabled="isSearchingFare" @click="searchFare()">Search for fare</v-btn>
    </div>
    <div>
      <v-btn text block color="warning" @click="cancelFareSearch()">Cancel</v-btn>
    </div>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
